import { Heading, SubHeading, Title } from "./components/Text";

function VolunteerWork() {
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Heading>Action in Africa</Heading>
        <SubHeading>Jan 2015 - Dec 2024</SubHeading>
      </div>
      <Title>Board Member</Title>
      <p style={{ marginTop: 16 }}>
        Served on Action in Africa's board of directors, assisting with
        fundraising, hiring decisions, and financial planning.
      </p>
      <p style={{ marginTop: 16 }}>
        Action in Africa is a non-profit organization that strives to educate,
        inspire, and empower people in Uganda by focusing on education and
        community development. Their goal is to provide sustained education,
        allowing individuals to reach their untapped potential and incite
        economic growth by becoming the next leaders, innovators, and
        entrepreneurs in their country.
      </p>
    </div>
  );
}

export default VolunteerWork;
